import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../assets/css/Form.css';
import logo from '../assets/images/Logo.svg';
import { useForm } from './hooks/useForm';
import { ReqPost } from '../config/Requests';
import Spinner from './UI/Spinner/Spinner';
import { Button } from 'react-bootstrap';
import { toast } from 'react-toastify';

function ResetPassword(props) {
	const [values, handleChange] = useForm({ email: '' });
	const [loading, setLoading] = useState(false);

	let navigate = useNavigate();
	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		console.log(values);
		ReqPost('forget-password', values)
			.then(res => {
				if (res.status === 200) {
					navigate(`/email-reset`);
				} else {
					toast.error(`Something went wrong`);
				}
			})
			.catch(() => {
				toast.error(`This email is not registered in our system`);
			})
			.finally(() => setLoading(false));
	};

	return (
		<div className='main-container form-bg-color'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container'>
				<div className='form-label-header'>RESET PASSWORD</div>
				<span className='text-reset'>
					Enter your email. We’ll send you a link to reset your password.
				</span>

				<form
					id='reset-password'
					className='form-container-inner'
					onSubmit={handleSubmit}
				>
					<input
						className='form-input text-center'
						type='email'
						id='email'
						value={values.email}
						onChange={handleChange}
						name='email'
						placeholder='Email'
						required
					/>
					{loading && <Spinner />}
					<button type='submit' className='btn-reset'>
						RESET PASSWORD
					</button>
					<span className='text-link-to'>
						Remember password?{' '}
						<Link to='/login' className='btn-link'>
							<strong> Log In </strong>
						</Link>{' '}
					</span>
				</form>
				<Link to='/'>
					<Button variant='outline-primary btn-back-main'>Back</Button>
				</Link>
				<br />
			</div>
		</div>
	);
}

export default ResetPassword;
